export default {
  items: [
    {
      title: 'Business Documentation Software',
      id: 'BusinessDocumentationSoftware',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'Business Documentation Software',
          to: { name : 'BusinessDocumentationSoftwareIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
